import { render, staticRenderFns } from "./LawSecurityDepositTypeList.vue?vue&type=template&id=796fe92d&"
import script from "./LawSecurityDepositTypeList.vue?vue&type=script&lang=js&"
export * from "./LawSecurityDepositTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawSecurityDepositTypeList.vue?vue&type=style&index=0&id=796fe92d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports